import { useQuery } from '@tanstack/react-query';
import { useSetConversation, useGetConversationById } from './lruConversation';
import { useMemoizedFn } from 'ahooks';
import { useEffect } from 'react';
import { queries } from 'services/queries';

/**
 * 更新会话缓存中的 TopBarInfo
 */
function useUpdateTopBarInfoConversation() {
  const setConversation = useSetConversation();
  const getConversationById = useGetConversationById();

  return useMemoizedFn((conversationId: string, topBarInfo: Conversation.TopBarInfo) => {
    const { remindScenes, remindTriggerContent, storeAlias, storeName, receptionAssistantName } =
      topBarInfo;

    const conversation = getConversationById(conversationId);
    if (!conversation) {
      return;
    }

    const { remindMark } = conversation;

    setConversation(conversationId, {
      ...conversation,
      remindScenes: remindMark ? remindScenes : [],
      remindTriggerContent: remindMark ? remindTriggerContent : [],
      storeAlias,
      storeName,
      topBarInfo,
      receptionAssistantName,
    });
  });
}

export function useConversationTopBarInfoLoader(conversationId: string) {
  const updateTopBarInfoConversation = useUpdateTopBarInfoConversation();

  const { data: topBarInfo } = useQuery({
    ...queries.conversations.topbarInfo(conversationId),
    enabled: !!conversationId,
  });

  useEffect(() => {
    if (topBarInfo) {
      const { conversationId } = topBarInfo;
      updateTopBarInfoConversation(conversationId, topBarInfo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topBarInfo]);

  return topBarInfo;
}
